import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export type RowAction = {
  /** Tooltip — hệ cũ chỉ hiện icon kèm title, không có chữ. */
  label: string;
  icon: LucideIcon;
  onClick: () => void;
  disabled?: boolean;
  tone?: "default" | "danger";
};

/**
 * Cột "Thao tác" của hệ cũ: một dãy icon nhỏ trên từng dòng, mỗi icon có tooltip.
 * Click không được lan lên `onRowClick` của dòng, nếu không bấm "Xoá" sẽ vừa xoá
 * vừa mở chi tiết.
 */
export function RowActions({ actions }: { actions: RowAction[] }) {
  if (actions.length === 0) return <span className="text-muted-foreground">—</span>;
  return (
    <div className="flex items-center justify-center gap-1">
      {actions.map((a) => (
        <button
          key={a.label}
          type="button"
          title={a.label}
          aria-label={a.label}
          disabled={a.disabled}
          onClick={(e) => {
            e.stopPropagation();
            a.onClick();
          }}
          className={cn(
            "h-7 w-7 grid place-items-center rounded-sm border border-transparent",
            "hover:border-border hover:bg-muted disabled:opacity-40 disabled:pointer-events-none",
            a.tone === "danger" ? "text-destructive" : "text-muted-foreground",
          )}
        >
          <a.icon className="h-3.5 w-3.5" />
        </button>
      ))}
    </div>
  );
}
